/**
 * Create page: prompt entry, then redirect into the streaming reader.
 */

import { useNavigate } from "react-router-dom";

import { useSession } from "@/app/useSession";
import { PromptEntry } from "@/features/create/PromptEntry";

export function CreatePage() {
  const { activeChild } = useSession();
  const navigate = useNavigate();

  if (!activeChild) {
    navigate("/");
    return null;
  }

  return (
    <PromptEntry
      childId={activeChild.id}
      onBookStarted={(bookId) => {
        navigate(`/book/${bookId}?streaming=1`);
      }}
    />
  );
}
